export const environment = {
  production: true,
  name: 'production',
  loglevel: 5,
  version: '5.19.0'
};
